// Single source of truth for FilterPanel range axes.
//
// Each axis declares its slider bounds and whether the upper end is
// "open-ended" — when true, dragging max to the slider's ceiling means
// "no upper limit on the API side" and the connector strips _max from
// the request entirely. Salt and deck count are unbounded in reality
// (decks rate 500+, prolific users have thousands of decks) so the
// slider caps are UI ceilings, not API ceilings.

export const RANGE_AXES = {
    power: { sliderMin: 1, sliderMax: 10, label: 'Power level', maxIsOpenEnded: false },
    bracket: { sliderMin: 1, sliderMax: 5, label: 'Bracket', maxIsOpenEnded: false },
    salt: { sliderMin: 0, sliderMax: 500, label: 'Salt rating', maxIsOpenEnded: true },
    deckCount: { sliderMin: 1, sliderMax: 100, label: 'Deck count', maxIsOpenEnded: true },
};

// Default range = full slider span. Open-ended axes use the cap as a
// sentinel that the connector recognises and drops from the request.
export const DEFAULT_RANGES = Object.fromEntries(
    Object.entries(RANGE_AXES).map(([axis, cfg]) => [axis, { min: cfg.sliderMin, max: cfg.sliderMax }])
);

// Per-axis sentinel pair used by the connector to decide whether to
// emit _min / _max query params. min === sliderMin and max === sliderMax
// both round-trip as "no constraint".
export const OPEN_ENDED_MIN = Object.fromEntries(
    Object.entries(RANGE_AXES).map(([axis, cfg]) => [axis, cfg.sliderMin])
);
export const OPEN_ENDED_MAX = Object.fromEntries(
    Object.entries(RANGE_AXES).map(([axis, cfg]) => [axis, cfg.sliderMax])
);

const RANGE_AXES_BY_CONTEXT = {
    decks: ['power', 'bracket', 'salt'],
    users: ['power', 'bracket', 'salt', 'deckCount'],
    commanders: ['power', 'bracket', 'salt', 'deckCount'],
};

export const getRangeAxesForContext = (context = 'decks') =>
    RANGE_AXES_BY_CONTEXT[context] || RANGE_AXES_BY_CONTEXT.decks;

export const buildDefaultFilters = (context = 'decks') => {
    const axes = getRangeAxesForContext(context);
    const ranges = {};
    axes.forEach((axis) => {
        ranges[axis] = { ...DEFAULT_RANGES[axis] };
    });
    return {
        query: '',
        colorFilters: '',
        archetypeMajor: '',
        archetypeMinor: '',
        ranges,
    };
};
